module.exports = __webpack_public_path__ + "static/media/fisdom_hni_advisory_logo_white.d298aa68.svg";